/* tslint:disable */
import './polyfills';
import 'document-register-element/build/document-register-element.js';

import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { MapcoreModule } from './components/mapcore.module';
import { environment } from './environment';
import './globals';

if (environment.production) {
    enableProdMode();
}

platformBrowserDynamic().bootstrapModule(MapcoreModule).catch(err => console.error(err));
